var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResourceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10983 7.2729C4.27346 7.2729 2.7793 5.77227 2.7793 3.92796C2.7793 2.08364 4.27346 0.583008 6.10983 0.583008C7.94619 0.583008 9.44036 2.08364 9.44036 3.92796C9.44036 5.77227 7.94619 7.2729 6.10983 7.2729Z",
    stroke: "#14A800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77611 11.9561C6.77611 12.3259 6.47819 12.6251 6.11001 12.6251C5.74183 12.6251 5.4439 12.3259 5.4439 11.9561V7.34082C3.19024 7.66894 1.44727 9.6033 1.44727 11.9561V15.9701C1.44727 16.3398 1.74519 16.6391 2.11337 16.6391H3.60563L4.11431 22.8054C4.14291 23.1516 4.43173 23.4182 4.7778 23.4182H7.44222C7.78828 23.4182 8.07711 23.1516 8.1057 22.8054L8.61439 16.6391H10.1066C10.4748 16.6391 10.7727 16.3398 10.7727 15.9701V11.9561C10.7727 9.6033 9.02977 7.66894 6.77611 7.34082V11.9561Z",
    stroke: "#14A800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceIcon);
export default __webpack_public_path__ + "static/media/resource_icon.84828a90dab8e908775b570f8d071e2d.svg";
export { ForwardRef as ReactComponent };